import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as modelHelper from "../../../../helpers/modelHelper";
import * as navigationActions from "../../../../actions/navigationActions";
import * as partialUpdatesActions from "../../../../actions/partialUpdatesActions";
import * as componentTypes from "../../../../constants/componentTypes";

import Modal, {MODAL_VARIANT_WARNING} from "../../../global/generic/Modal";
import Button, {BUTTON_VARIANT_WARNING} from "../../../global/generic/Button";

import imgBoltFilled from "../../../../resources/img/svgicons/bolt-solid.svg";
import imgLoader from "../../../../resources/img/loader-orange.svg";

class PartialUpdatesModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hideAutoVisible: false,
            remainingTime: props.inactivityTimer,
            updateInProgress: false
        };
    }
    handleApplyPartialUpdates = () => {
        this.setState({updateInProgress: true});
        this.props.dispatchApplyPartialUpdate(this.props.tabId);
    };

    setUpTimer = () => {
        this.timer = setInterval(() => {
            this.state.remainingTime > 0
                ? this.setState({remainingTime: this.state.remainingTime - 1})
                : (clearInterval(this.timer), (this.timer = null), this.handleApplyPartialUpdates());
        }, 1000);
    };

    componentDidMount() {
        if (!this.timer) {
            this.setUpTimer();
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data && this.props.data !== null) {
            this.setState({remainingTime: this.props.inactivityTimer, hideAutoVisible: false});
            !this.timer ? this.setUpTimer() : null;
        }
    }
    remindMeLater = () => {
        window.storeProvider.startPartialUpdateInterval(this.props.remindInterval * 60);
        clearInterval(this.timer);
        this.timer = null;
        this.props.dispatchResetBlockedUiAction();
        this.props.dispatchClosePartialUpdatesModalAction();
    };
    hideTimer = () => {
        this.setState({hideAutoVisible: true});
        clearInterval(this.timer);
        this.timer = null;
    };
    getListOfPartialUpdates = () => {
        const partialUpdatesContent = [];
        if (!this.props.data) {
            return null;
        }
        for (const [key, value] of Object.entries(this.props.data)) {
            partialUpdatesContent.push(
                <div key={key} className="padding-bottom-10">
                    <span className="color-primary font-size-1_25em">{key}</span>
                    {value === false ? (
                        <div className="padding-bottom-5 ">
                            <Translate value="partialUpdates.cantBeUsedForYourDbVersion" />
                        </div>
                    ) : (
                        value.map((updateDetail, detailIndex) => {
                            return (
                                <div key={detailIndex} className="padding-bottom-5 ">
                                    <div className="font-size-1em">
                                        <span>{updateDetail.version}</span>
                                        {updateDetail.versionName &&
                                        updateDetail.version !== updateDetail.versionName ? (
                                            <span> - {updateDetail.versionName}</span>
                                        ) : null}
                                    </div>
                                    <div className="font-size-0_75em">
                                        <span>{updateDetail.changelog}</span>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            );
        }
        return partialUpdatesContent;
    };

    getPreparedList = () => {
        return (
            <div className="width-100 flex flex-column flex-gap-10px">
                <span>{translate("partialUpdates.preparedUpdatesMessage")}:</span>
                <div
                    onScroll={this.hideTimer}
                    className="col-12 slim-scroll padding-left-30 border-warning padding-top-10"
                    style={{height: "30vh"}}
                >
                    {this.getListOfPartialUpdates()}
                </div>
            </div>
        );
    };

    getContent = () => {
        if (this.state.updateInProgress) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <ReactSVG src={imgBoltFilled} className="react-svg-icon fill-warning width-30" />
                    <span className="font-size-1_5em">{translate("partialUpdates.applying")}...</span>
                    <span className="text-muted flex-gap padding-">{translate("general.mayTakeAWhile")}.</span>
                    <span className="loader">
                        <img alt="loading" src={imgLoader} />
                    </span>
                </React.Fragment>,
                "flex flex-column flex-gap-0_6rem padding-30 flex-align-center-vertical"
            );
        }

        return modelHelper.buildModalSection(
            this.getPreparedList(),
            "flex flex-wrap flex-align-center-horizontal slim-scroll"
        );
    };
    getCountDown = () => {
        return (
            <span className="text-center color-black font-size-0_75em flex-child">
                {!this.state.hideAutoVisible ? (
                    <Translate value="partialUpdates.updateAutomatically" time={this.state.remainingTime} />
                ) : (
                    <React.Fragment>&nbsp;</React.Fragment>
                )}
            </span>
        );
    };

    getFooter = () => {
        if (this.state.updateInProgress) {
            return null;
        }

        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="flex flex-end flex-gap-10px">
                    <Button
                        label={<Translate value="general.later" />}
                        variant={BUTTON_VARIANT_WARNING}
                        onClick={this.remindMeLater}
                    />
                    <Button
                        label={<Translate value="general.applyNow" />}
                        variant={BUTTON_VARIANT_WARNING}
                        onClick={this.handleApplyPartialUpdates}
                    />
                </div>
                {this.getCountDown()}
            </React.Fragment>,
            "flex-column"
        );
    };

    render() {
        return (
            <Modal
                onClick={this.hideTimer}
                tabId={this.props.tabId}
                variant={MODAL_VARIANT_WARNING}
                className="superior-modal"
                header={modelHelper.buildModalSection(<Translate value={"partialUpdates.partialUpdates"} />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "35%", maxWidth: "80%"}}
                closeHidden
            />
        );
    }
}

const mapStoreToProps = (state) => {
    return {
        redlikeVersion: state.module.softwareVersion,
        data: state.global.partialUpdates,
        inactivityTimer: state.settings.partialUpdatesInactivityTimer,
        remindInterval: state.settings.partialUpdatesRemindInterval
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchClosePartialUpdatesModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.PARTIAL_UPDATE_MODAL));
        },
        dispatchResetBlockedUiAction: () => {
            dispatch(navigationActions.setBlockedUi(false));
        },
        dispatchApplyPartialUpdate: (tabId) => {
            dispatch(partialUpdatesActions.applyAllPartialUpdates(tabId));
        }
    };
};

export default PartialUpdatesModal = connect(mapStoreToProps, mapDispatchToProps)(PartialUpdatesModal);
